import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'rxnt-progress-bar',
  templateUrl: './rxnt-progress-bar.component.html',
  styleUrl: './rxnt-progress-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RxntProgressBarComponent implements OnChanges {
  // Victor: progress bar can be hidden via this prop or via *ngIf in the parent
  // The difference is being able to reserve space, to avoid layout shift
  @Input() show: boolean = true;
  @Input() value: number | undefined;

  isDeterminate: boolean = false;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['value']) {
      this.isDeterminate = this.value !== null && this.value !== undefined;
    }
  }
}
